export default __webpack_public_path__ + "static/media/bulb.fd9a2796.svg";